import urls from "@/constants/urls";
import axios from "axios";

export const useCompareToLastYear = () => {
  /**
   * Fetches comparison data for a campaign against the same period last year.
   * @param {string} oid - Organization ID.
   * @param {string} cid - Campaign ID.
   * @param {Object} params - Additional query parameters.
   * @returns {Promise<any>} A promise that resolves to an array containing the
   * comparison data and any error that occurred during the request.
   */
  const fetchCompareToLastYear = async (oid, cid, params = {}) => {
    const url = urls.compareToLastYear(oid, cid);

    return await axios
      .get(url, { params })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response ? error.response.data : error));
  };

  return {
    fetchCompareToLastYear,
  };
};
